export default __webpack_public_path__ + "static/pragicts-secops-services-msoc-980ed2a866e548963e69f036cd2a05a2.jpg";